export default __webpack_public_path__ + "static/media/HoloRay_Logo_256.50af2c20.png";